import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'

import DatePicker from 'material-ui/DatePicker'

import {getMonth} from 'utils/date'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		lease: doc(state, props.objectID)
	})
)

export class BreakDateTill extends Component{
	render(){
		let { props } = this
		return(
				<div style={{margin: "0px", display:"inline-block", width: "40%"}}>
                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgb(255, 0, 0)", fontWeight: "100", fontSize: "10px"}} >
                    Move out date</p>
                    <DatePicker
                        style={{
                            color: "#000"
                        }}
                        textFieldStyle={{
                            fontSize: "16px"
                            , width: "100px"
                            , height: "36px"
                            , color: "#000"
                        }}
                        underlineStyle={{
                            borderBottom: props.lease.breakDateTill ? "0px solid" : "0px solid"
                        }}
                        inputStyle={{color: "#000"}}
                        underlineDisabledStyle={{borderBottom: "0px solid"}}
                        hintText="Select"
						formatDate= {(date)=>new Date(date).getDate().toString() + ' ' + getMonth(new Date(date).getMonth()).toString() + ' ' + new Date(date).getFullYear().toString()}
                        hintStyle={{top: "8px"}}
                        style={{width: "100px", height: "35px", marginTop: "8px"}}
                        value={(props.lease.breakDateTill)?new Date(props.lease.breakDateTill):""}
                        onChange={(evt, value)=>{
                            props.STAGE({
                                _id: props.objectID
                              , breakDateTill: Moment(value).format("YYYY-MM-DD")
                            })}
                        }
                    />
                </div>
		)
	}
}

export default connect(select, dataActions)(BreakDateTill)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/BreakDateTill.js